import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {SponsorPage} from "../sponsor/SponsorPage";
import {ADVERTISE_PATH} from "../sponsor/sponsorRoutes";

/**
 * Public, pre-rendered self-serve advertising booking page (`/advertise`, ui#496; renamed from
 * `/sponsor` on 2026-08-17 with the rest of the buyer-facing wording).
 *
 * Thin wrapper (mirrors {@link ./PricingRoute.tsx}): `<Seo>` plus the page.
 *
 * `noindex` in every language tree (kitecorp/transferify-ui#3610). Since 2026-08-17 the booking flow is
 * a step a buyer reaches from {@link ./AdvertisingRoute.tsx}, the presentation page the Resources menu
 * and the sitemap point at: that page is the one indexable door to the offer, and this one indexed
 * beside it would compete with it for the same searches. `<Seo noindex>` emits the robots tag and
 * withholds the canonical, og:url and hreflang alternates, as it does for the `/sponsor` shell. A
 * booking's return links (`/sponsor?booking=<id>`, which that shell forwards here) are unaffected.
 * `path` still names the page, which is what its title reads.
 */
export function Component() {
	const {sponsor} = useMessages();
	return (
		<>
			<Seo title={sponsor.seo.title} description={sponsor.seo.description} path={ADVERTISE_PATH} noindex/>
			<SponsorPage/>
		</>
	);
}
